import type { AppModule } from "../types";
import { s } from "./strings";

export const calendarModule: AppModule = {
  name: "calendar",
  routes: {
    shell: [
      {
        path: "/calendar",
        handle: { title: s.pageTitle },
        lazy: () => import("./pages/CalendarPage").then((m) => ({ Component: m.CalendarPage })),
      },
    ],
  },
  sidebar: [{ id: "CALENDAR", label: s.navLabel, path: "/calendar", icon: "calendar", alt: s.navAlt }],
};
